module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/rds-2014-09-01.paginators.json
// module id = 473
// module chunks = 0